import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
//import template = require('dojo/text!./emailPicker.html');
import '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/Container/ExpandableSectionTypes";
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import { EmailEditorTypes } from "./emailTypes";
import emailForm from './emailForm';


class EmailFinder extends compose(FinderBaseV2) {
    //templateString = template;

    mailList: Array<EmailEditorTypes.savedMail>;
    tableEntryPoint: HTMLDivElement;
    tableNewButton: HTMLDivElement;
    dataTable: MdsLax<InstanceType<typeof StaticTable>>;
    newMailButton: HTMLButtonElement;

    private idList: Array<string> = [];

    //###war-crimes###
    private flagTableIsReady = false;
    private resultTableContainer:HTMLDivElement;
    private resultTableObserver = new MutationObserver(lang.hitch(this, (this as any)._onMutate_Table));

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    //#region postCreate
    postCreate(): void {
        this.setupFinderWithCallfunctions(
            "Webtool_API_EmailTransmission__Finder_GetConfig",
            "Webtool_API_EmailTransmission__Finder_GetResults",
            lang.hitch(this, this._onClick_TableRow),
            lang.hitch(this, this._tableFormatter),
            {
                neededUserRole: null,
                callback: lang.hitch(this, this._onClick_CreateNew)
            }
        );

       
    }

    private _onMutate_Table(){
        let remBtnList = this.resultTableContainer.querySelectorAll("button[remBtnInit=\"false\"]");
        if (typeof remBtnList != 'undefined'){
            if (remBtnList.length > 0){
                for (let delBtn of remBtnList as any as Array<HTMLButtonElement>){
                    delBtn.addEventListener("click", lang.hitch(this, this._onClick_RemoveEntry));
                    delBtn.setAttribute("remBtnInit", "true");
                }
            }
        }
    }

    private _onClick_TableRow(row: StaticTable.StaticTableRow<EmailEditorTypes.EmailTransmissionEntity>, rowGroup: StaticTable.StaticTableRowGroup<EmailEditorTypes.EmailTransmissionEntity>) {

        let mailform = new emailForm();// rowGroup.entity.ID, { isHistoryContext: true, isProjectContext: false, contextEntity: null }, false);
        
        mailform.show("dlg", rowGroup.entity.mail_subject, this.getTabContainerName());

        mailform.setup(rowGroup.entity.ID, { isHistoryContext: true,contextEntity: null });
    }
    
    private _tableFormatter(cell: StaticTable.StaticTableCell<any>): boolean {
        try {
            this.idList.push(cell.tableRow.rowGroup.entity.ID);
        } catch { }
        switch (cell.name) {
           
            case 'deleteBtnCell':
                if (this.flagTableIsReady == true){
                    let remBtn = document.createElement("button");
                    remBtn.setAttribute("class", "mds-hover-bright mds-button-base roundest secondaryBG");
                    remBtn.setAttribute("remBtnInit", "false");
                    remBtn.setAttribute("mailID", cell.tableRow.rowGroup.entity.ID);
                    remBtn.title = this.translations["email_mailPicker_popup_Header"];
    
                    let remIco = document.createElement("a");
                    remIco.setAttribute("class", "far fa-trash-alt");
                    remIco.setAttribute("mailID", cell.tableRow.rowGroup.entity.ID);
                    remBtn.appendChild(remIco);
    
                    //cell.value = remBtn.outerHTML;
                    cell.value = " "; // https://imgur.com/a/qmLHEPV
                    cell.tableCellNode.appendChild(remBtn);
                }

                return true;
                break;
        }
        return false;
    }

    private _onClick_RemoveEntry(ev: Event) {
        try{
            ev.stopPropagation();
        }catch{}
        let mailID = (ev.target as HTMLButtonElement).getAttribute("mailid")
        this.emit("enty-delete", {ID:mailID});
    }

    private _onClick_CreateNew() {
        let mailform = new emailForm();
        mailform.setMailFormContext({ isHistoryContext: true, contextEntity: null })

        mailform.show("dlg", "new", this.getTabContainerName());

        

    }

    public requestReload() {
        try{
            this.reloadData();
        }catch{
            console.warn("mailPicker: unable to reload data");
        }
    }

}

export default mdsWidget(EmailFinder);
